import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
  },
  header: {
    fontSize: 15,
    marginBottom: 5,
    textAlign: "center",
    fontWeight: "bold",
  },
  table: {
    display: "table",
    width: "100%",
    marginTop: 5,
  },
  row: { flexDirection: "row", borderBottom: "1px solid black" },
  cell: { flex: 1, padding: 3 },
  bold: { fontWeight: "bold" },
});

// Create Document Component
const MyDocument = ({ data, sizes }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Text style={styles.header}>Bill Summary</Text>

      <View style={styles.table}>
        {/* Table Header */}
        <View
          style={[
            styles.row,
            styles.bold,
            { backgroundColor: "#f0f0f0", padding: 2 },
          ]}
        >
          <View style={styles.cell}>
            <Text>ID</Text>
          </View>
          <View style={{ ...styles.cell, flex: 2 }}>
            <Text>Service</Text>
          </View>
          <View style={styles.cell}>
            <Text>Size</Text>
          </View>
          <View style={styles.cell}>
            <Text>Pcs</Text>
          </View>
          <View style={styles.cell}>
            <Text>Weight</Text>
          </View>
          <View style={styles.cell}>
            <Text>Rate</Text>
          </View>
          <View style={styles.cell}>
            <Text>Amount</Text>
          </View>
          <View style={styles.cell}>
            <Text>Total</Text>
          </View>
        </View>

        {/* Table Rows */}
        {data?.sub_billing_lines.map((row, index) => {
          const findSize = sizes?.find(
            ({ size_id }) => size_id === row?.size_id
          );
          let size = findSize
            ? `${findSize?.size_from} - ${findSize?.size_to}`
            : "-";
          return (
            <View style={styles.row} key={index}>
              <View style={styles.cell}>
                <Text>{index + 1}</Text>
              </View>
              <View style={{ ...styles.cell, flex: 2 }}>
                <Text>{row?.ser_name}</Text>
              </View>
              <View style={styles.cell}>
                <Text>{size}</Text>
              </View>
              <View style={styles.cell}>
                <Text>{Number(row.bill_pcs).toFixed(2)}</Text>
              </View>
              <View style={styles.cell}>
                <Text>{row.bill_cts?.toFixed(2)}</Text>
              </View>
              <View style={styles.cell}>
                <Text>{Number(row?.bill_rate).toFixed(2)}</Text>
              </View>
              <View style={styles.cell}>
                <Text>{row?.bill_amount?.toFixed(2)}</Text>
              </View>
              <View style={styles.cell}>
                <Text>{row?.bill_total?.toFixed(2)}</Text>
              </View>
            </View>
          );
        })}
      </View>
    </Page>
  </Document>
);
export default MyDocument;
